import React from 'react'

const Fullstack_Python = () => {
  return (
    <div>
            {/* collapseTenth */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingTenth">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTenth" aria-expanded="false" aria-controls="collapseTenth"> Core Python<span className="toggle-icon ms-auto"></span></button>
                </h2>
                <div id="collapseTenth" className="accordion-collapse collapse" aria-labelledby="headingTenth" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Course Overview, Introduction</li>
                      <li>Python Setup Fundamentals - Datatypes, Operators</li>
                      <li>Control Flow</li>
                      <li>Data Structure</li>
                      <li>Functions</li>
                      <li>Strings - String Functions</li>
                      <li>Arrays - Array Functions</li>
                      <li>File Handling - Modes, with Statement</li>
                      <li>Modules - Import module using import & fromimport</li>
                      <li>Exception Handling - Types of Exceptions</li>
                      <li>Decorators - Generators - yield keyword</li>
                      <li>OOPs - Class, Object, Constructors, Inheritance - Single, Multiple, Multilevel, Hierarchical, Hybrid Inheritance, Polymorphism, Data Abstraction, Encapsulation - Private, Public, Protected.</li>
                      <li>Database Connectivity</li>
                      <li>Numpy Library in Python</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* collapseEleventh */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingEleventh">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEleventh" aria-expanded="false" aria-controls="collapseEleventh"> Advance Python<span className="toggle-icon ms-auto"></span></button>
                </h2>
                <div id="collapseEleventh" className="accordion-collapse collapse" aria-labelledby="headingEleventh" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Flask Web development Framework</strong>:
                    <ul>
                      <li>Introduction</li>
                      <li>Installation, Flask first program</li>
                      <li>Routings</li>
                      <li>Variable Rules</li>
                      <li>HTTP Methods</li>
                      <li>Templates</li>
                      <li>Web templating System, Delimiters</li>
                      <li>Static Files - CSS, JS, Image, etc.</li>
                      <li>CRUD Operations using database - Registration, Display, Edit, Delete, File Handling, Login using session, Cookies.</li>
                      <li>Web / Database Applications in Python</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>Django Web Application Framework</strong>:
                    <ul>
                        <li>Introduction</li>
                        <li>Installation, Django first program, first app</li>
                        <li>Django Admin - Create Multiple Users</li>
                        <li>Folder Structure, Routing</li>
                        <li>Migrations</li>
                        <li>Custom Models</li>
                        <li>Security in Django - CSRF Protection, Clickjacking Protection</li>
                        <li>CRUD Operations using database - Registration, Display, Edit, Delete, File Handling, Login using session, Cookies</li>
                        <li>Static Files - CSS, JS, Image, etc.</li>
                        <li>Middleware</li>
                        <li>Messages</li>
                        <li>Form Model - Forms in Django</li>
                        <li>User Authentication</li>
                        <li>Django Validations</li>
                        <li>Mapping - One to One, One to Many, Many to One, Many to Many Mapping</li>
                        <li>Major Project & Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>Django REST API</strong>:
                    <ul>
                        <li>Django REST API - Introduction, Installation</li>
                        <li>Serialization & Deserialization</li>
                        <li>CRUD using Function based View</li>
                        <li>CRUD using Class based View</li>
                        <li>Concrete View</li>
                        <li>Throttling in Django REST framework</li>
                        <li>Filtering in Django REST framework</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
  )
}

export default Fullstack_Python